import Icon from '../icon/Icon'
import { IconNames, TextFieldSizes, TextFieldType } from '../Types'
import { forwardRef, InputHTMLAttributes, LegacyRef } from 'react'
import styles from './TextField.module.scss'
import Typography from '../typography/Typography'
interface TextFieldPropType extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  type?: TextFieldType
  icon?: IconNames
  sizes?: TextFieldSizes
  description?: string
  error?: boolean
  onClear: (e: any) => void
  disabled?: boolean
  readOnly?: boolean
  value?: string | number
  endAdornment?: string
  className?: string
  id?: string
  data_cy?: string
}
const TextField = forwardRef(
  (
    {
      label,
      type = 'text',
      icon,
      sizes = 'medium',
      description,
      error,
      onClear,
      disabled,
      readOnly,
      value,
      endAdornment,
      placeholder = '',
      className = '',
      id,
      data_cy,
      ...props
    }: TextFieldPropType,
    ref: LegacyRef<HTMLInputElement>,
  ) => {
    return (
      <div
        className={`
           ${styles['textfield-class']} ${disabled ? styles['disabled'] : ''} ${className}`}
        id={id}
        data-cy={data_cy}
      >
        <div
          className={
            styles['input-container'] +
            ' ' +
            styles[sizes] +
            ' ' +
            `${error ? styles['error'] : ''}` +
            ' ' +
            `${icon ? styles['has-icon'] : ''}` +
            ' ' +
            `${endAdornment ? styles['has-adornment'] : ''}`
          }
        >
          {icon && (
            <Icon type="inherit" name={icon} className={styles['icons']} />
          )}
          <input
            className={styles['input']}
            type={type}
            ref={ref}
            disabled={disabled}
            readOnly={readOnly}
            value={value}
            placeholder={placeholder || ''}
            {...props}
          />
          <label htmlFor="textfield" className={styles['label']}>
            {label}
          </label>
          {(value || endAdornment) && (
            <div className={styles['end-adornment-container']}>
              {value && !disabled && !readOnly && (
                <div onClick={onClear} className={styles['close']}>
                  <Icon type="mediumEmphasis" name="close" size={'small'} />
                </div>
              )}
              {endAdornment && (
                <Typography
                  component="span"
                  variant="bodyM"
                  className={styles['end-adornment']}
                >
                  {endAdornment}
                </Typography>
              )}
            </div>
          )}
          <fieldset className={styles['fieldset']}>
            <legend className={styles['legend']}>{label}</legend>
          </fieldset>
        </div>
        {(error || description) && (
          <Typography
            component="span"
            variant="bodyS"
            className={
              styles['helper-text'] +
              ' ' +
              `${error ? styles['error-text'] : ''}`
            }
          >
            <Icon type="inherit" name="info-circle" size={14} />
            {description}
          </Typography>
        )}
      </div>
    )
  },
)

TextField.displayName = 'TextField'
export default TextField
